import { CompType } from '@aloft/toolkit-shared';
import { Text } from '@react-pdf/renderer';

import { badgeStyles } from '../styles.ts';

type CompTypeBadgeProps = {
  compType: CompType;
  compact?: boolean;
  fullText?: boolean;
};

export const CompTypeBadge = ({ compType, compact, fullText }: CompTypeBadgeProps) => {
  let text: string = compType;

  if (fullText) {
    if (compType === 'aiv') {
      text = 'As-Is';
    } else if (compType === 'arv') {
      text = 'After-Repair';
    }
  }

  return (
    <Text
      style={[
        compact ? badgeStyles.compact : badgeStyles.badge,
        compType ? badgeStyles[compType] : {},
        fullText ? { textTransform: 'none', width: compact ? 52 : 60 } : {},
      ]}
    >
      {text}
    </Text>
  );
};
